import * as actionTypes from '../types/survey';

export function surveyList() {
  return {
    type: actionTypes.SURVEY_LIST
  };
}
export function surveyListSuccess(payload) {
  return {
    type: actionTypes.SURVEY_LIST_SUCCESS,
    payload
  };
}
export function surveyListFail(payload) {
  return {
    type: actionTypes.SURVEY_LIST_FAIL,
    payload
  };
}

export function saveSurveyResult(payload) {
  return {
    type: actionTypes.SAVE_SURVEY_RESULT,
    payload
  };
}

export function saveSurveyResultSuccess(payload) {
  return {
    type: actionTypes.SAVE_SURVEY_RESULT_SUCCESS,
    payload
  };
}

export function saveSurveyResultFail(payload) {
  return {
    type: actionTypes.SAVE_SURVEY_RESULT_FAIL,
    payload
  };
}

export function getListSurveys(payload) {
  return {
    type: actionTypes.GET_LIST_SURVEYS,
    payload
  };
}

export function getListSurveysSuccess(payload) {
  return {
    type: actionTypes.GET_LIST_SURVEYS_SUCCESS,
    payload
  };
}

export function getListSurveysFail(payload) {
  return {
    type: actionTypes.GET_LIST_SURVEYS_FAIL,
    payload
  };
}

export function getSurveyResult(payload) {
  return {
    type: actionTypes.GET_SURVEY_RESULT,
    payload
  };
}

export function getSurveyResultSuccess(payload) {
  return {
    type: actionTypes.GET_SURVEY_RESULT_SUCCESS,
    payload
  };
}

export function getSurveyResultFail(payload) {
  return {
    type: actionTypes.GET_SURVEY_RESULT_FAIL,
    payload
  };
}

export function addSurvey(payload) {
  return {
    type: actionTypes.ADD_SURVEY,
    payload
  };
}

export function addSurveySuccess(payload) {
  return {
    type: actionTypes.ADD_SURVEY_SUCCESS,
    payload
  };
}

export function addSurveyFail(payload) {
  return {
    type: actionTypes.ADD_SURVEY_FAIL,
    payload
  };
}

export function toggleActivationSurvey(payload) {
  return {
    type: actionTypes.TOGGLE_ACTIVATION_SURVEY,
    payload
  };
}

export function toggleActivationSurveySuccess(payload) {
  return {
    type: actionTypes.TOGGLE_ACTIVATION_SURVEY_SUCCESS,
    payload
  };
}

export function toggleActivationSurveyFail(payload) {
  return {
    type: actionTypes.TOGGLE_ACTIVATION_SURVEY_FAIL,
    payload
  };
}
